import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { CommonsSessionStorageService } from 'ib-web-commons/dist/utils';
import { DatalayerConstantsType } from 'ib-web-commons/app/core/ib-datalayer/ib-datalayer-constants';

const controllerInfo = {
    module: 'ib-speqs-module',
    inject: ['object', '$uibModalInstance', 'AncillariesUtilsService', '$compile', '$scope', 'CurrencyService', 'localStorageService', '$filter', '$rootScope', 'AncillariesConstants', 'ModalServiceAncillaries', 'DatalayerUtilsService', 'DatalayerUtils', '$timeout',  'CommonsConstants', 'CommonsSessionStorageService', 'AncillariesService', 'DatalayerConstants', 'CommonsUtilService'],
    required: []
};
export class SpeqsController implements ng.IController {
    public model: any;
    public tooltipComponent: any;
    public totalFormatted: any;
    public infoChangeBaggforSpeq: boolean = false;
    public user: string;
    public showModalAvios = false;
    public flightAviosInfo: boolean;
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $compile: angular.ICompileService,
        private $scope: angular.IScope,
        private CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $filter: angular.FilterFactory,
        private $rootScope: CommonsRootScope,
        private AncillariesConstants: AncillariesConstant,
        private ModalServiceAncillaries,
        private DatalayerUtilsService,
        private DatalayerUtils: DatalayerUtils,
        private $timeout: ng.ITimeoutService,
        private CommonsConstants: CommonsConstantsType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private AncillariesService: any,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsUtilService: CommonsUtilService
    ) {
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
    }

    /**
     * Calculate total to pay for all speqs selected
     */
    calculateTotalSpeqs = (): any => {
        let totalSpeqs = 0;
        const currency: CommonsCurrencyModel.CurrencyResponse = this.localStorageService.get('currency');
        angular.forEach(this.model.passengers, (pas) => {
            angular.forEach(pas.trips, (trip) => {
                if (trip.totalPrice > 0) {
                    totalSpeqs = totalSpeqs + trip.totalPrice;
                }
            });
        });
        this.totalFormatted = this.CurrencyService.formatPrice(currency, totalSpeqs, true);
        // mostrar u ocultar modal avios
        totalSpeqs > 0 ? (this.showModalAvios = true) : (this.showModalAvios = false);
    };

    $onInit = (): void => {
        this.model = this.object;
        this.orderSpeqs(this.model);
        this.calculateTotalSpeqs();
        this.checkIfHaulHaveBaggage();
        this.calculateBundleSpeqs();
    };

    updateDataLayerAndDigitalData = (accepted): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        if (accepted) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries('confirmar equipaje especial', 'click', 'anadir');
        }
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.AncillariesUtilsService.isBookingFlow() ?
            this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, quadrigam) :
            this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, quadrigam);
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.DatalayerUtilsService.addDigitalDataInfo({Step: this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES});
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    };

    /**
     * Cancel modal
     * @returns Reject promise
     */
    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.$uibModalInstance.dismiss();
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData(false);
        }
    };

    /**
     * Close modal
     * @return Resolve promise
     */
    accept = (): void => {
        const flow = this.localStorageService.get('flowApp');
        if(this.localStorageService.get('bundleHaveSpeqs') !== undefined) {
            this.bundleAlert();
        }
        this.DatalayerUtils.setSpeqsEventCart(this.model);
        this.DatalayerUtilsService.updateDatalayerActionForAncillaries(
            this.AncillariesConstants.DATALAYER_INFO.SPEQ_CONFIRM,
            this.AncillariesConstants.DATALAYER_INFO.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.CONFIRM
        );
        const ancillariesSpeq = this.localStorageService.get('genAviosAncillariesSpeq');
        this.AncillariesService.getAviosAncillariesSummaryReq(
            ancillariesSpeq,
            this.AncillariesConstants.TYPE_ANCILLARIE.SPEQS
        );
        this.$uibModalInstance.close();
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData(true);
        }
    };

    /**
     * Cancel modal
     * @returns Reject promise
     */
    goBaggageModal = (): void => {
        this.$uibModalInstance.dismiss();
        this.$rootScope.$broadcast('openBaggages');
    };

    // Tooltip Hover
    tooltipHover = (trip: any, piece: any, position: any, event: any): void => {
        if (
            !this.AncillariesUtilsService.isTouchDevice() === true &&
            !this.AncillariesUtilsService.isResolutionToMobile() === true
        ) {
            this.buildTooltipHover(trip, piece, position, event);
        }
    };

    /**
     * Generate tooltip and append to DOM
     * @param {Object} trip Trip information
     * @param {Object} piece Speq piece information
     * @param {String} position Button Right | Left
     * @param {Object} event
     */
    buildTooltipHover = (trip: any, piece: any, position: any, event: any): void => {
        let tooltipRight;
        if (angular.element('#tooltipHover').length > 0) {
            angular.element('#tooltipHover').remove();
        }
        if (piece.subtype === this.AncillariesConstants.SPEQ_TYPE.SURFBOARD && position === this.AncillariesConstants.DIRECTION.RIGHT && trip.speqsChoosed < 3 && trip.speqsChoosed > 0) {
            tooltipRight = angular.element(
                '<div  id="tooltipHover" class="ib-add-bag-tooltip-max" style="display: block">' +
                    '<div class="ib-add-bag-tooltip-max__container">' +
                    '<span class="ib-add-bag-tooltip-max__title">' +
                    this.$filter('translate')('SPEQS_TOOLTIP_MAX_SPEQS_LIMIT_TITLE') +
                    '</span>' +
                    '<span class="ib-add-bag-tooltip-max__subtitle">' +
                    this.$filter('translate')('SPEQS_TOOLTIP_MAX_SURFBOARD_INFO') +
                    '</span>' +
                    '</div>' +
                    '<div class="ib-add-bag-tooltip-max__arrow"></div>' +
                    '</div>'
            );
        } else {
            tooltipRight = angular.element(
                '<div  id="tooltipHover" class="ib-add-bag-tooltip-max" style="display: block">' +
                    '<div class="ib-add-bag-tooltip-max__container">' +
                    '<span class="ib-add-bag-tooltip-max__title">' +
                    this.$filter('translate')('SPEQS_TOOLTIP_MAX_SPEQS_LIMIT_TITLE') +
                    '</span>' +
                    '<span class="ib-add-bag-tooltip-max__subtitle">' +
                    this.$filter('translate')('SPEQS_TOOLTIP_MAX_SPEQS_LIMIT_INFO') +
                    '</span>' +
                    '</div>' +
                    '<div class="ib-add-bag-tooltip-max__arrow"></div>' +
                    '</div>'
            );
        }

        if (position === this.AncillariesConstants.DIRECTION.RIGHT && trip.maxAdditionalPieces === trip.speqsChoosed) {
            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
        } else if (
            piece.subtype === this.AncillariesConstants.SPEQ_TYPE.SURFBOARD &&
            position === this.AncillariesConstants.DIRECTION.RIGHT &&
            trip.maxAdditionalPieces !== trip.speqsChoosed && trip.speqsChoosed < 3 && trip.speqsChoosed > 0 &&
            piece.quantySelected > 0
        ) {
            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
        }
    };

    /**
     * Check type of device, build tooltip and append to view
     * @param {Object} trip Trip where selected the speqs
     * @param {Object} piece Piece selected
     * @param {String} position Button position clicked by user (Left | Right )
     * @param {Object} event Object event
     */
    tooltipTouch = (trip: any, piece: any, position: any, event: any): void => {
        if (position === this.AncillariesConstants.DIRECTION.LEFT && piece.quantySelected > 0) {
            piece.quantySelected--;
            trip.speqsChoosed--;
            this.model.quantySelected--;
            this.calculateTotalTrip(trip);
        } else if (
            position === this.AncillariesConstants.DIRECTION.RIGHT &&
            piece.quantySelected < piece.maxAdditionalSubtypePieces &&
            trip.speqsChoosed < trip.maxAdditionalPieces
        ) {
            piece.quantySelected++;
            trip.speqsChoosed++;
            this.tooltipHover(trip, piece, position, event);
            this.calculateTotalTrip(trip);
            //   buildTooltipTouch(trip, piece, position, event);
            if(Number(piece.quantySelected) === 1) this.DatalayerUtils.setSpeqsSelectItem(trip, piece);
        }
        const genTransformSpeqs = this.AncillariesService.genTripsAncillaries(this.model.passengers);
        this.AncillariesService.getReqAviosAncillariesSpeq(genTransformSpeqs);
    };

    /**
     * Calculate total price of trip passenger with number
     * of baggages selected by user
     * @param {Object} trip Information of trip
     */
    calculateTotalTrip = (trip: any): void => {
        let i,
            j,
            numSpeq,
            numSpeqInterval,
            speqsCounter = 0;
        trip.totalPrice = 0;
        for (i = 0; i < trip.pieces.length; i++) {
            if (trip.pieces[i].quantySelected > 0) {
                numSpeq = 0;
                for (j = 0; j < trip.pieces[i].availablePriceRanges.length; j++) {
                    numSpeqInterval = 1;
                    if (numSpeq <= trip.pieces[i].quantySelected) {
                        speqsCounter =
                            (trip.pieces[i].availablePriceRanges[j].to - trip.pieces[i].availablePriceRanges[j].from) + 1;
                        while (numSpeqInterval <= speqsCounter && numSpeq < trip.pieces[i].quantySelected) {
                            trip.totalPrice = trip.totalPrice + trip.pieces[i].availablePriceRanges[j].amount;
                            numSpeqInterval++;
                            numSpeq++;
                        }
                    }
                }
            }
        }
        this.calculateTotalSpeqs();
    };

    /**
     * Calculate maximun of speqs depeding of data returned by service
     * @param {Object} trip Trip information
     * @param {String} position Position (right | left)
     */
    addSpeqInTotalCounter = (trip: any, position: any): any => {
        let infoTooltip = '';
        if (trip.maxAdditionalPieces === trip.speqsChoosed) {
            infoTooltip =
                '<span class="ib-add-bag-tooltip-max__title">' +
                this.$filter('translate')('SPEQS_TOOLTIP_MAX_SPEQS_LIMIT_TITLE') +
                '</span>';
            infoTooltip =
                infoTooltip +
                '<span class="ib-add-bag-tooltip-max__subtitle">' +
                this.$filter('translate')('SPEQS_TOOLTIP_MAX_SPEQS_LIMIT_INFO') +
                '</span>';
        }
        return infoTooltip;
    };

    /**
         * Open modal for show speq information
         * @param {String} description Name of piece selected
         * @param {String} subtype Type of piece selected
         */
    openSpeqInformation = (trip: any, piece: any) => {
        const description: any = piece.description;
        const subtype: any = piece.subtype;
        this.ModalServiceAncillaries.openSpeqInformation({ description: description, subtype: subtype });
        //this.DatalayerUtils.spegsEcommerceEventClick(this.model);
        this.DatalayerUtils.setSpeqsSelectItem(trip, piece);
    };

    /**
     * open modal avios speq
     */
    openModalAviosSpeqAncillaries = (): void => {
        this.AncillariesService.manageAviosModal(this.localStorageService.get('genAviosAncillariesSpeq'));
    };
    calculateBundleSpeqs = (): void => {
        const bundleSelected:any = this.localStorageService.get('selectedBundle');
        this.model.passengers.forEach(passenger => {
            passenger.trips.forEach(trip => {
                if(!trip.defaultAditionalPieces) {
                    trip.defaultAditionalPieces = trip.maxAdditionalPieces;
                } else {
                    trip.maxAdditionalPieces = trip.defaultAditionalPieces;
                }
            });
        });
        if (bundleSelected) {
            bundleSelected.items.forEach(item => {
                if(item.type === 'SPECIAL_EQUIPMENT') {
                    this.model.passengers.forEach(passenger => {
                        passenger.trips.forEach(trip => {
                            trip.maxAdditionalPieces = trip.defaultAditionalPieces - item.quantityPassAndTrips;
                        });
                    });
                }
            });
        }
    };
    bundleAlert = () => {
        let messageHasToBeShown = false;
        this.model.passengers.forEach(pass => {
            pass.trips.forEach(trip => {
                if(trip.defaultAditionalPieces === trip.speqsChoosed) {
                    messageHasToBeShown = true;
                }
            });
        });
        if(messageHasToBeShown) {
            this.localStorageService.set('bundleHaveSpeqs', true);
        } else {
            this.localStorageService.set('bundleHaveSpeqs', false);
        }
    };

    orderSpeqs = (speqsModel) => {
        const result = [];
        const speqsOrder = ['BICYCLE', 'SURFBOARD', 'SKI_SNOW', 'GOLF_EQUIPMENT', 'FISHING_EQUIPMENT', 'SCUBA_DIVING'];
        if(speqsModel) {
            for(let i = 0; i < speqsModel.passengers.length; i++) {
                for (let j = 0; j < speqsModel.passengers[i].trips.length; j++) {
                    for (let l = 0; l < speqsModel.passengers[i].trips[j].pieces.length; l++) {
                        switch (speqsModel.passengers[i].trips[j].pieces[l].subtype) {
                                case 'BICYCLE':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 1;
                                    break;
                                case 'SURFBOARD':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 2;
                                    break;
                                case 'SKI_SNOW':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 3;
                                    break;
                                case 'GOLF_EQUIPMENT':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 4;
                                    break;
                                case 'FISHING_EQUIPMENT':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 5;
                                    break;
                                case 'SCUBA_DIVING':
                                    speqsModel.passengers[i].trips[j].pieces[l].order = 6;
                                    break;
                        }
                    }
                }
            }
            for(let i = 0; i < speqsModel.passengers.length; i++) {
                for (let j = 0; j < speqsModel.passengers[i].trips.length; j++) {
                    for (let l = 0; l < speqsModel.passengers[i].trips[j].pieces.length; l++) {
                        // eslint-disable-next-line prefer-arrow-callback, array-callback-return
                        speqsModel.passengers[i].trips[j].pieces.sort(function (a, b) {
                            if (a.order > b.order) {
                                return 1;
                            }
                            if (a.order < b.order) {
                                return -1;
                            }
                        });
                    }
                }
            }
        }
    };

    private checkIfHaulHaveBaggage (): void {
        let compatibleHaul: boolean = true;
        let hasUnits: boolean = false;
        let compatibleUser: boolean = false;
        let fareData: any;

        //Get summary info in BKI or MMB else CKI
        if (this.CommonsSessionStorageService.get('breakdownInfo')) {
            fareData = this.CommonsSessionStorageService.get('breakdownInfo');
        } else if (this.CommonsSessionStorageService.get('summaryInfo')) {
            fareData = this.CommonsSessionStorageService.get('summaryInfo');
        }

        //Check if the user has franchise pieces
        if (fareData !== null) {
            for (let i = 0; i < fareData.context.segments.length; i++) {
                //Check if there is any long haul segment
                if (fareData.context.segments[i].haul === 'LH') {
                    compatibleHaul = false;
                }
                //Check if the user have a franchise baggage
                for (let j = 0; j < fareData.context.segments[i].passengerCoupons.length; j++) {
                    for (let k = 0; k < fareData.context.segments[i].passengerCoupons[j].franchisePieces.length; k++) {
                        if (this.AncillariesConstants.BAGGAGE_SUBTYPES.includes(fareData.context.segments[i].passengerCoupons[j].franchisePieces[k].subtype)) {
                            if (fareData.context.segments[i].passengerCoupons[j].franchisePieces[k].units >= 1) {
                                hasUnits = true;
                            }
                        }
                    }
                }
            }
            //Check if there is any user with a compatible frequent flyer type
            for (let i = 0; i < fareData.context.passengers.length; i++) {
                if (fareData.context.passengers[i].frequentFlyer) {
                    if (1 <= fareData.context.passengers[i].frequentFlyer.level && fareData.context.passengers[i].frequentFlyer.level <= 3) {
                        compatibleUser = true;
                    }
                }
            }
        }

        if (compatibleUser && compatibleHaul && hasUnits) {
            this.infoChangeBaggforSpeq = true;
        }
    }
}


try {
    SpeqsController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SpeqsController.name, SpeqsController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SpeqsController.$inject = controllerInfo.inject;
    mod.controller(SpeqsController.name, SpeqsController);
}